import { useNavigate } from "react-router-dom"
import MTable from "../../../../components/mtable"
import CollapsingSection from "../../../../components/CollapsingSection"

export default function CompanySparks({ companyId }) {

    const navigate = useNavigate()

    const mapper = { columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Display Name",
            value: (item) => item.displayName
        },
        {
            label: "Description",
            value: (item) => item.description
        }
    ]}

    return (
        <CollapsingSection
            title="Sparks"
            actionButtons={<button className="text" onClick={() => navigate('manage-sparks')}>Manage Access</button>}
        >
            <MTable path={'sparks'} queryParams={{ companyId }} mapper={mapper} />
        </CollapsingSection>
    )
}
